import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';

import { ApiError, DataTablesService, MessageService, GuidService } from '../../../../core';
import { MercadoFilter } from '../mercado-filter';
import { Mercado } from '../../mercado';
import { isSituacaoAtivo, isSituacaoInativo } from '../../situacao';
import { MercadoCrudHttpService } from '../../services';

@Component({
    selector: 'sgt-mercado-filter-modal',
    templateUrl: './mercado-filter-modal.component.html',
    styleUrls: ['./mercado-filter-modal.component.less']
})
export class MercadoFilterModalComponent implements OnInit {
    @Input() idModal: string;
    /** Situação padrão. Se informada sempre será considerada esta situação no filtro */
    @Input() situacao: number;
    @Output() selectEntity = new EventEmitter<Mercado>();
    elModal: any;
    isSelectRegistered = false;

    entities: Mercado[];
    idDataTable: string;
    dataTable: any;
    filter: MercadoFilter;
    @ViewChild('modalBody') modalBody: ElementRef;


    constructor(private el: ElementRef,
                private dataTablesService: DataTablesService,
                private messageService: MessageService,
                private mercadoCrudHttpService: MercadoCrudHttpService,
                private guidService: GuidService) { }

    ngOnInit() {
        this.create();
        this.idDataTable = this.guidService.generate();
    }

    /** Cria o modal */
    private create() {
        this.elModal = jQuery(this.el.nativeElement).find('.modal') as any;
    }

    open(filter: MercadoFilter = null) {
        this.filter = filter ? filter : new MercadoFilter();
        this.search();
        this.elModal.modal({keyboard: false});
    }

    close() {
        this.elModal.modal('hide');
    }

    search() {
        // Se tiver a situação padrão informada, sempre adicionamos ela no filtro
        if (this.situacao) {
            this.filter.situacao = this.situacao
        }

        this.mercadoCrudHttpService.searchWithFilter(this.filter)
        .subscribe(
            entities => {
                this.entities = entities;
                this.afterSearch();
            },
            (error: ApiError) => this.messageService.error(error.message, 'Erro ao pesquisar os mercados', error)
        );
    }

    private afterSearch() {
        jQuery(this.modalBody.nativeElement).scrollTop(0);
        this.showTable();
    }

    showTable() {
        this.dataTablesService.showTable(jQuery(this.el.nativeElement).find(`#${this.idDataTable}`), this.dataTable, {
            pageLength: 15,
            searching: false,
            order: [[0, 'asc']],
            columnDefs: [
                {orderable: true, targets: 0},
                {
                    targets: 1,
                    createdCell: (td, cellData, rowData, row, col) => {
                        if (cellData) {
                            td.title = cellData;
                        }
                    }
                }
            ],
        }).then(dataTable => this.dataTable = dataTable);
    }

    /** Verifica se a situação do mercado é ativo */
    isSituacaoAtivo(entity: Mercado): boolean {
        return isSituacaoAtivo(entity?.situacao);
    }

    /** Verifica se a situação do mercado é inativo */
    isSituacaoInativo(entity: Mercado): boolean {
        return isSituacaoInativo(entity?.situacao);
    }

    /** Ao selecionar o mercado, emitimos o evento de seleção e fechamos o modal */
    onSelectEntity(entity: Mercado) {
        this.selectEntity.emit(entity);
        this.close();
    }
}
